(() => {
  // 各種ボタンとモーダル取得
  const termsCheckModalButton = document.querySelector(".termsCheckModalButton");
  const privacyCheckModalButton = document.querySelector(".privacyCheckModalButton");

  const termsPanelWrapper = document.getElementById("termsPanelWrapper--cart");
  const privacyPanelWrapper = document.getElementById("privacyPanelWrapper--cart");

  // 各モーダルの close ボタン取得
  const termsCloseButton = termsPanelWrapper.querySelector(".close-button");
  const privacyCloseButton = privacyPanelWrapper.querySelector(".close-button");

  const termsCheck = document.querySelector(".termsCheck");
  const checkoutButton = document.getElementById("checkout");

  if (!termsCheckModalButton || !privacyCheckModalButton || !termsPanelWrapper || !privacyPanelWrapper || !termsCloseButton || !privacyCloseButton || !termsCheck || !checkoutButton) {
    //console.warn("一部の要素が見つかりませんでした。スクリプトを中止します。");
    return;
  }

  let lastFocusedElement = null;
  let openedModalWrapper = null;

  function openModal(wrapper, closeBtn) {
    lastFocusedElement = document.activeElement;
    wrapper.classList.add("open");
    closeBtn.focus();
    openedModalWrapper = wrapper;
    document.body.style.overflow = "hidden";
    [...document.body.children].forEach((el) => {
      if (el !== wrapper) el.setAttribute("inert", "");
    });
  }

  function closeModal() {
    if (!openedModalWrapper) return;
    openedModalWrapper.classList.remove("open");
    document.body.style.overflow = "";
    [...document.body.children].forEach((el) => {
      el.removeAttribute("inert", "");
    });
    if (lastFocusedElement) lastFocusedElement.focus();
    openedModalWrapper = null;
  }

  // 各ボタンでそれぞれのモーダルを開く
  termsCheckModalButton.addEventListener("click", () => {
    openModal(termsPanelWrapper, termsCloseButton);
  });
  privacyCheckModalButton.addEventListener("click", () => {
    openModal(privacyPanelWrapper, privacyCloseButton);
  });

  // 閉じるボタンで閉じる
  termsCloseButton.addEventListener("click", closeModal);
  privacyCloseButton.addEventListener("click", closeModal);

  // 背景クリックで閉じる
  termsPanelWrapper.addEventListener("click", (e) => {
    if (e.target === termsPanelWrapper) closeModal();
  });
  privacyPanelWrapper.addEventListener("click", (e) => {
    if (e.target === privacyPanelWrapper) closeModal();
  });

  // チェックボックス制御
  termsCheck.addEventListener("change", function () {
    checkoutButton.disabled = !this.checked;
  });
})();
